@if (!error()) {
   @if (downloaded()) {
    <mat-icon class="icon-success icon-5x">check</mat-icon>
   }
   @else {
     <mat-spinner color="accent"></mat-spinner>
   }
  <span>{{downloaded() ? 'Zip creado correctamente' : 'Creando archivo zip'}}</span>
}
@else {
  <mat-icon class="icon-error icon-5x">error</mat-icon>
  <span>Error al crear el zip: No se encontraron imagenes válidas</span>
}